// extracted by mini-css-extract-plugin
module.exports = {"title":"plans_title__N4OnO","cards":"plans_cards__h88ph"};